import { Component, HostListener, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-journey-timeline',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './journey-timeline.component.html',
  styleUrls: ['./journey-timeline.component.scss']
})
export class JourneyTimelineComponent implements AfterViewInit {
  scrollProgress = 0;
  
  @ViewChild('timelineSection', { static: false }) timelineSection!: ElementRef;

  ngAfterViewInit() {
    // Initial calculation in a timeout to let layout settle
    setTimeout(() => this.onWindowScroll(), 0);
  }

  @HostListener('window:scroll', [])
  onWindowScroll() {
    if (!this.timelineSection) return;
    
    const element = this.timelineSection.nativeElement;
    const rect = element.getBoundingClientRect();
    const windowHeight = window.innerHeight;
    
    // We want to start filling when the top of the timeline section is at 75% of the viewport height
    const startPoint = windowHeight * 0.75;
    
    // Distance from the startPoint to the top of the element
    const distanceToTop = startPoint - rect.top;
    const maxDistance = rect.height * 0.8; // reach 100% a bit earlier to ensure it fills even if at bottom of page
    
    if (distanceToTop <= 0) {
      this.scrollProgress = 0;
    } else if (distanceToTop >= maxDistance) {
      this.scrollProgress = 100;
    } else {
      this.scrollProgress = (distanceToTop / maxDistance) * 100;
    }
  }
}
